import { useState, useEffect } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EventDescription from "./EventDescription";
import EventNameHeader from "./EventNameHeader";
import Container from "src/components/container/Container";
import { useAuthContext } from "src/auth/useAuthContext";
import getEventsByHandle from "src/services/events/getEventsByHandle";
import LoadingInPage from "src/components/LoadingInPage";
import ActionModel from "./ActionModel";
import useModalControl from "src/hooks/useModalControl";

const EventDetails = () => {
    const navigate = useNavigate();
    const { handle } = useParams();
    const location = useLocation()
    const { user, logout } = useAuthContext();
    const [eventData, setEventData] = useState({});

    const [loading, setLoading] = useState(true);

    const handleBackEventDetails = () => {
        navigate("/events");
    };

    const getData = async (user, handle, logout) => {
        setLoading(true);
        const data = await getEventsByHandle(user, handle, logout, location.state?.vendorID);
        setEventData(data?.data);

        setLoading(false);
    };
    useEffect(() => {
        if (handle && user) {
            getData(user, handle, logout);
        }
    }, [handle, user]);
    const { open, handleCloseModal, handleOpenModal } = useModalControl()
    const [type, setType] = useState("")

    return (

        <Container>
            {open && <ActionModel open={open} close={handleCloseModal} type={type} eventData={eventData} />}
            <Stack spacing={2}>
                <Paper elevation={10}>
                    {loading ? (
                        <LoadingInPage />
                    ) : (
                        <Stack p={{ xs: 1, md: 3 }}>
                            <EventNameHeader
                                eventData={eventData}
                                handleBackEventDetails={handleBackEventDetails}
                                getData={getData}
                            />
                            <Stack pl={{ xs: 1, md: 6 }} spacing={{ xs: 2, md: 3 }}>
                                {/* <Box pt={2}>
                                    <EventsCards counts={counts} />
                                </Box> */}
                                <Box>
                                    <EventDescription
                                        eventData={eventData}
                                        setEventData={setEventData}
                                        handle={handle}
                                    />
                                </Box>
                                {/* <Stack spacing={1}>
                                    <Typography variant="h5">Ticket Sales</Typography>
                                    <Paper>
                                        <TableSales eventData={eventData} counts={counts} />
                                    </Paper>
                                </Stack> */}
                                <Stack>
                                    <Typography variant="h4">Admin Actions</Typography>
                                    <Stack direction={"row"} gap={2} sx={{ marginTop: "20px", flexWrap: "wrap" }}>
                                        <Button variant="contained"

                                            onClick={() => {
                                                setType("approved");
                                                handleOpenModal()
                                            }}
                                        >
                                            Approve Event
                                        </Button>
                                        <Button variant="outlined"
                                            onClick={() => {
                                                setType("rejected")
                                                handleOpenModal()
                                            }}
                                        >
                                            Reject
                                        </Button>
                                        <Button variant="outlined"

                                            onClick={() => {
                                                setType("needs_improvement");
                                                handleOpenModal()
                                            }}
                                        >
                                            Needs Improvement
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Stack>

                        </Stack>
                    )}
                </Paper>
            </Stack>
        </Container>
    );
};

export default EventDetails;
